module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-gb-313a510a553b03f0bca804cbcb4d1d8a.svg";